import React, { type FC, memo, use } from "react";
import { Button, useOverlayState } from "@heroui/react";
import { Sparkles } from "@gravity-ui/icons";

import { BinaleAgentModal } from "./BinaleAgentModal";
import { UserContext } from "@domain/context/UserProvider";
import { useTranslation } from "@domain/intl/useTranslation";
import { HoverGlow } from "@ui-components/HoverGlow";
import { ProductColors } from "@ui-components/ProductColors";

const BinaleAgentButtonImpl: FC = () => {
    const { t } = useTranslation();
    const { isAdminWrite } = use(UserContext);
    const modal = useOverlayState();

    if (!isAdminWrite) {
        return null;
    }

    return (
        <>
            <HoverGlow sparkle brightIcon>
                <Button
                    variant="primary"
                    className={`relative z-2 text-sm ${ProductColors.AIGradient.className}`}
                    onPress={modal.open}
                >
                    <Sparkles className="size-4" />
                    {t("app.agent.button")}
                </Button>
            </HoverGlow>
            <BinaleAgentModal isOpen={modal.isOpen} onClose={modal.close} />
        </>
    );
};

export const BinaleAgentButton = memo(BinaleAgentButtonImpl);
